import { getAuthToken } from '@dynamic-labs/sdk-react-core';
import { DocumentNode } from 'graphql';

import { GET_MARKETPLACE_USERS_QUERY } from '@repo/api-core-toolkit';

import { sendGraphqlRequest } from '../graphql';

type User = {
  userId: string;
  addresses: string[];
  pfp: string;
  stoodioUsername: string;
};

type Props = {
  userIds?: string[];
  searchTerm?: string;
};

export const searchOrGetUsers = ({ userIds, searchTerm }: Props) =>
  sendGraphqlRequest<User[]>({
    authToken: getAuthToken(),
    query: GET_MARKETPLACE_USERS_QUERY as DocumentNode,
    variables: {
      userIds: userIds || [],
      searchTerm: searchTerm || null,
    },
    field: 'getMarketplaceUsers',
  });
